import { Injectable, OnDestroy, Inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BehaviorSubject, Subscription } from 'rxjs';

import { AbstractHypeService } from '../../../Common/Layout/services/abstract-hype.service';
import { SocialRouteModel } from '../../SocialRouter/models/social-route.model';
import { SocialRoutingService } from './social-routing.service';
import { SocialRouteTypeEnum } from '../../SocialRouter/enums/social-route-type.enum';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';

@Injectable()
export class SocialHypeService extends AbstractHypeService implements OnDestroy {

    public currentRoute: SocialRouteModel;
    private subscriptions: Subscription[] = [];
    public buttonClicked$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        public socialRoutingService: SocialRoutingService,
        public localizationService: LocalizationService,
        @Inject(APP_BASE_HREF) public appBaseHref: string
    ) {
        super();
        this.subscriptions.push(
            this.socialRoutingService.getCurrentRoute$().subscribe(
                route => {
                    this.currentRoute = route;
                    this.initializeHype();
                }
            )
        );
    }

    private initializeHype(): void {
        this.buttonClicked$.next(false);
        switch (this.currentRoute.type) {
            case SocialRouteTypeEnum.themeManagement:
                this.hypeConfig = {
                    icon: null,
                    headingText: null,
                    line1Text: null,
                    line2Text: null,
                    linkText: 'Social.intelligence.themeManagement.hype.link',
                    iconUrl: this.appBaseHref + 'assets/images/landing.svg',
                    class: 'social-hype',
                    line1Html: this.localizationService.transform('Social.intelligence.themeManagement.hype.text1')
                };
                break;
            default:
                break;
        }
        this.hypeConfigProvider.next(this.hypeConfig);
    }

    buttonClicked(): void {
        this.buttonClicked$.next(true);
    }

    secondaryButtonClicked(): void {}

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

}

